import { EntityId } from '@reduxjs/toolkit';
import { Update } from '@reduxjs/toolkit';
import httpAdapter, { _apiUrlFactory } from '../../../_config/api-provider';

const httpService = httpAdapter();

const prefix = 'accounting/rib-type';
const apiribTypeUrl = _apiUrlFactory(prefix);

export const all = async () => {
	return  httpService.get(`${apiribTypeUrl('')}`);
};

export const add = async (mode: any): Promise<Partial<any>> => {
	return  httpService.post(apiribTypeUrl(''), mode);
};

export const update = async (mode: Update<any>): Promise<any> => {
	const { id, ...otherProps } = mode;
	return  httpService.put(apiribTypeUrl(`${id}`), otherProps);
};

export const _delete = async (id: EntityId) => {
	return  httpService.delete(apiribTypeUrl(`${id}`));
  }